import styled from "styled-components";

function getInitialPositionCss(props) {
    let css = '';
    let offset = props.offset || '0px';
    let posCalc = 'calc(-'+props.size + ' + ' + offset + ');';
    let margin = props.open ? 'calc(-' + props.offset + ' - 1px);' : null;
    if (props.left) {
        css += 'left: ' + posCalc;
        css += 'margin-left: '+ margin;
    } else if (props.right) {
        css += 'right: ' + posCalc;
        css += 'margin-right: '+ margin;
    } else if (props.top) {
        css += 'top: ' + posCalc;
        css += 'margin-top: '+ margin;
    } else if (props.bottom) {
        css += 'bottom: ' + posCalc;
        css += 'margin-bottom: '+ margin;
    }
    if (props.left || props.right) {
        css += 'top: 0;bottom: 0;';
    } else {
        css += 'right: 0;left: 0;';
    }
    return css;
}

function getTransformVals(props) {
    let xy = [0,0];
    if (props.top) {
        xy[1] = props.open ? props.size : '0';
    } else if (props.bottom) {
        xy[1] = props.open ? '-'+props.size : '0';
    } else if (props.left) {
        xy[0] = props.open ?  props.size : '0';
    } else if (props.right) {
        xy[0] = props.open ? '-'+props.size : '0';
    }
    return xy[0] + ', ' + xy[1]
}

const SlidingPane = styled.div`
    -webkit-transition: ${(props) => props.duration || '0.3s'} ease-in-out;
    -moz-transition: ${(props) => props.duration || '0.3s'} ease-in-out;
    -o-transition: ${(props) => props.duration || '0.3s'} ease-in-out;
    transition: ${(props) => props.duration || '0.3s'} ease-in-out;
    transform: translate(${(props) => getTransformVals(props)});
    position: fixed;
    ${(props) => !!props.left || !!props.right ? 'width: ' + props.size : 'height: ' + props.size };
    ${(props) => !!props.left || !!props.right ? 'top: 0; bottom: 0' : 'left: 0; right: 0' };
    ${(props) => getInitialPositionCss(props)};
    z-index: 999;
`;

export default SlidingPane;